import { Component, OnInit }  from '@angular/core';
import { Router }             from '@angular/router';

import { DeveloperService }  from '../services/developers/developer.service';

import { RequestService } from '../services/request.service';
import { UsersComponent } from '../users/users.component';
import { ProviderService } from '../services/providers/provider.service';
import { Auth } from '../services/auth.service';

@Component({
  moduleId: module.id,
  selector: 'my-developers',
  templateUrl: 'developers.component.html',
  styleUrls: [ '../users/users.component.css' ]
})

export class DevelopersComponent extends UsersComponent {

  constructor(
    protected router: Router,
    protected developerService: DeveloperService,
    protected providerService:ProviderService,
    protected requestService : RequestService,
    protected auth: Auth) {
      super(router, developerService,providerService);
  }

  selectedProviderIndex: string
  hasBOUsersPermission: Boolean = false;

  protected getDetailUrl(): string {

    return '/developer/' + this.selectedUser.id;
  };

  protected getUserString(): string {

    return 'developer';
  };

  protected getUsersString(): string {

    return 'Developers';
  };

  ngOnInit(): void {
    this.getUsers({ limit: this.usersPerGet })
    this.getProviders()
    this.hasBOUsersPermission = this.auth.hasBOUsersPermission();
  }

  add(): void {

    if (this.createCalled) {

      return;
    }
    if (this.newUser.name==undefined || this.newUser.password==undefined || this.newUser.email==undefined) {
      this.alertAdd=true;
      return;
    }
    let name = this.newUser.name.trim();
    if (!name) {
      this.alertAdd=true;
      return;
    }

    let password = this.newUser.password.trim();
    if (!password || password.length < 6) {
      this.alertAdd=true;
      return;
    }

    let email = this.newUser.email.trim();
    if (!email) {
       this.alertAdd=true;
      return;
    }

    this.createCalled = true;
    this.developerService.create({
      name: name,
      password: password,
      email: email,
      provider: this.providers[this.selectedProviderIndex].id
    })
      .then(user => {

        this.createCalled = false;
        this.pushOrdered(user);
        this.selectedUser = null;
        this.newUser = {};
        this.configPages()
        this.alertCreated=true;
        return this;
      })
      .catch(error => {

        this.createCalled = false;
        alert(error._body.message)
        return Promise.reject(error.message || error);
      });
  }

  onReset(user) : void {
    if (!confirm("Do you really wan't to send a reset password to this user email?"))
      return;

    this.requestService.makeRequest({
      method: 'get',
      urlKey: 'changeDeveloperPassword',
      urlParams: {
        id: user.id
      },
    })
    .then((response: any) => {
      alert("Password reset sent!");
    })
    .catch((err) => {
      alert("Error while sending developer password reset.");
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/developers/developers.component.ts